module.exports = __webpack_public_path__ + "img/DSC_2770-xl.bb40dbbd.png";